import {ACTION_CODE} from './_actionCode';
import {TrainingStudentTypesService} from '../../services';
import {ErrorModel, ResultModel} from '../../models';
import {LoggerService} from '../../services';

const FUNCTION_CODE = 'UPDATE_TRAINING_STUDENTTYPE';

export async function updateTrainingStudentType(
    userData: Record<string, string>,
    id: number,
    updatedTrainingStudentType: Record<string, any>
) {
    try {

        LoggerService.logInfo('Action - updateTrainingStudentType - Start');

        const updateTrainingStudentTypeResult = await TrainingStudentTypesService.updateTrainingStudentType(userData, id, updatedTrainingStudentType);

        LoggerService.logInfo('Action - updateTrainingStudentType - End - Success');

        return ResultModel.newSuccessResult(updateTrainingStudentTypeResult);
    }
    catch (error) {
        LoggerService.logInfo('Action - updateTrainingStudentType - End - Error');

        const newErr = ErrorModel.newError({
            code: `${ACTION_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
        LoggerService.logError(error);

        return ResultModel.newErrorResult(newErr);
    }
}
